// Copyright (c) 2016 Deere & Company

import AccordionState, {
    getDefaultState as getReportsAccordionDefaultState
} from '../../../shared/components/smart-accordion/state/accordion';
import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import Facets, {getDefaultState as getFacetsDefaultState} from './facets';
import OpenPipsSummary, {getDefaultState as getOpenPipsSummaryDefaultState} from '@deere/cps-it.warranty-model-factory/lib/open-pips-summary';
import PipProducts, {getDefaultState as getPipProductsDefaultState} from '../../shared/state/pip-products';
import SearchByDropDown, {getDefaultState as getSearchByDropDownDefaultState} from '../../shared/state/search-by-dropdown';
import SearchFilters from '../../../shared/state/search-filters';
import {getDefaultState as getSearchFiltersDefaultState} from '../../shared/state/search-filters';
import t from 'tcomb';

const OpenPipState = t.struct({
    busyCounter: BusyCounter,
    facets: Facets,
    hasSearchResults: t.Boolean,
    openPipsSummary: OpenPipsSummary,
    pipProducts: PipProducts,
    pipProductsFiltered: PipProducts,
    reportsAccordion: AccordionState,
    searchByDropDown: SearchByDropDown,
    searchFilters: SearchFilters,
    searchQueryString: t.String
}, 'OpenPipState');

export const getDefaultState = () =>
    new OpenPipState({
        busyCounter: getBusyCounterDefaultState(),
        facets: getFacetsDefaultState(),
        hasSearchResults: false,
        openPipsSummary: getOpenPipsSummaryDefaultState(),
        pipProducts: getPipProductsDefaultState(),
        pipProductsFiltered: getPipProductsDefaultState(),
        reportsAccordion: getReportsAccordionDefaultState('all-pips-report'),
        searchByDropDown: getSearchByDropDownDefaultState(),
        searchFilters: getSearchFiltersDefaultState(),
        searchQueryString: ''
    });

export default OpenPipState;



// WEBPACK FOOTER //
// ./src/pip/open-pips/state/index.js